function App() {
    return (
        <div>
             hello world by mobile
        </div>
    );
}

export default App;
